import { IconName } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MenuProps } from "primereact/menu"

export interface ButtonMenuModelProps {
  onClick: React.MouseEventHandler<HTMLDivElement>
  icon: IconName
  label: string
}

export const ButtonMenuModel = (
  items: Array<ButtonMenuModelProps>
): MenuProps["model"] => {
  return items?.map(({ onClick, icon, label }) => ({
    template: (
      <div
        className='tw-text-sm tw-flex tw-cursor-pointer tw-flex-row tw-items-center tw-gap-4 tw-px-4 tw-py-2 hover:tw-bg-gray-100'
        onClick={onClick}
      >
        <FontAwesomeIcon
          icon={["fal", icon]}
          className='tw-font-bold'
        />
        <span>{label}</span>
      </div>
    ),
  }))
}
